
declare var dataLayer: any;

export interface iUtilsTM { createCookie: Function, readCookie: Function }
export class TagManager {

	private utils: iUtilsTM;

	private clearEcommerce() {
        dataLayer.push({ ecommerce: null });
    }
	constructor(utils: iUtilsTM) {
		this.utils = utils;
	}

	eventViewItemList(cars_results: any, searchContext?: {
		search_string?: string;
		origin_city?: string;
		destination_city?: string;
		pickup_time?: string;
		dropoff_time?: string;
	}) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

		let items: any = [];
		cars_results.forEach((element: any, index: any) => {
			items.push({
				item_id: element.id,
				item_name: element.nombre,
				price: element.precio,
				item_brand: element.marca,
				item_category: element.gama.nomb,
				item_category2: element.rentadora,
				quantity: 1,
				index: index,
				currency: 'COP'
			})
		});

		const payload: any = {
			event: "view_item_list",
			ecommerce: {
				items: items
			}
		};

		if (searchContext) {
			payload.search_context = {
				search_string:    searchContext.search_string    ?? '',
				origin_city:      searchContext.origin_city      ?? '',
				destination_city: searchContext.destination_city ?? '',
				pickup_time:      searchContext.pickup_time      ?? '',
				dropoff_time:     searchContext.dropoff_time     ?? ''
			};
		}
		
		dataLayer.push(payload);
	}

	eventPaymentFailed(event:any,orderData:any) {
		 const {
			value,
			currency = 'COP',
			failure_reason,
			items = []
		} = orderData;

		// Limpia ecommerce previo
		dataLayer.push({ ecommerce: null });

		// Envía evento
		dataLayer.push({
			event: "payment_failed",
			ecommerce: {
				value: value || 0,
				currency: currency,
				failure_reason: failure_reason || null,
				items: items // Array con { item_name, item_id, price, quantity }
			}
		});
	}

 	viewItem(event: any, orderData: any) {
        const { items = [] } = orderData;
        this.clearEcommerce();
        dataLayer.push({
            event: "view_item",
            ecommerce: { items }
        });
    }


	eventItem(element: any, event: any) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: event,// "select_item",
			ecommerce: {
				items: [{
					item_id: element.id,
					item_name: element.nombre,
					price: element.precio,
					item_brand: element.marca,
					item_category: element.gama,
					item_category2: element.rentadora,
					quantity: 1,
					index: element.index,
					currency: element.rent_currency ?? 'COP'
				}]
			}
		});
	}

	eventItemOnly(event: any) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: event,// "select_item",
		});
	}

	onPurchase(element: any) {

		var purchase_cookie = this.utils.readCookie('purchase');

		if (purchase_cookie == element.transaction_id) {
			return;
		}

		this.utils.createCookie('purchase', element.transaction_id, 5, Domain);

		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: "purchase",
			ecommerce: {
				currency: "COP",
				transaction_id: element.transaction_id,
				items: [{
					item_id: element.id,
					item_name: element.modelo,
					price: Math.round(element.precio),
					item_brand: element.marca,
					item_category: element.gama,
					item_category2: element.rentadora,
					quantity: 1,
					index: 1,
					currency: 'COP'
				}],
				value: Math.round(element.precio)
			}
		});
	}
}